import { createIdMapFromList } from 'util/ImmutableCollectionOperations';
import DomainObjectView from 'domain/DomainObjectView';
import { User } from 'domain/User';
import { Map } from 'immutable';
import { ActionType, UserList, UserAction } from './types';

export const initialState: UserList = {
  isLoading: true,
  userMapById: Map<number, DomainObjectView<User>>(),
};
// eslint-disable-next-line default-param-last
const userReducer = (state = initialState, action: UserAction): UserList => {
  switch (action.type) {
    case ActionType.SET_USER_LIST_LOADING: {
      return { ...state, isLoading: action.isLoading };
    }
    case ActionType.ADD_USER:
    case ActionType.UPDATE_USER: {
      return { ...state, userMapById: state.userMapById.set(action.user.id as number, action.user) };
    }
    case ActionType.REMOVE_USER: {
      return { ...state, userMapById: state.userMapById.remove(action.user.id as number) };
    }
    case ActionType.REFRESH_USER_LIST: {
      return { ...state, userMapById: createIdMapFromList(action.userList) };
    }
    default:
      return state;
  }
};

export default userReducer;
